<div class="inner-block relative">
  <div class="row">
    <div class="col-12">
      <dot-loader [visibility]="loading()" [large]="true"></dot-loader>

      @if (!loading()) {
        <h2>{{ priceListHeading }}</h2>

        @if (showOverWrittenPriceComponent) {
          <expandable-header
            class="margin-top-bottom--2x"
            backgroundColor="white"
            heading="h3"
            padding="true"
            [text]="overWrittenHeadingText"
          >
            <date-span [start]="priceList.valid_from" [end]="priceList.valid_to"></date-span>

            <edit-overwritten-price
              [publishers]="publishers"
              [priceList]="priceList"
              (onOverwrittenPricesUpdated)="reloadPriceList($event)"
              (onClearOverwrittenPrices)="clearOverwrittenPrices()"
            ></edit-overwritten-price>
          </expandable-header>
        }

        <expandable-header
          class="margin-top-bottom--2x"
          backgroundColor="white"
          heading="h3"
          padding="true"
          text="Lägg till programformatspris"
        >

          <div class="row align-items-center">
            <div class="col">
              <woo-dropdown
                [items]="programFormats"
                [(ngModel)]="selectedProgramFormat"
                name="selectedProgramFormat"
                inputId="select-programFormat"
                labelText="Välj Programformat"
                notFoundText="Inga Placeringspriser hittades."
              ></woo-dropdown>
            </div>

            <div class="col">
              <woo-number-input
                id="program-pris"
                labelText="Pris"
                name="programPrice"
                inputId="program-pice"
                required="true"
                [(ngModel)]="newProgramPrice"
                [formatterOptions]="{allowLeadingSign: true, allowDecimals: false}"
              ></woo-number-input>
            </div>

            <div class="col">
              <button type="submit" class="button primary" [disabled]="disableAddProgramPrice()" (click)="addProgramPrice()">Lägg till</button>
            </div>
          </div>

        </expandable-header>

        <div class="account__card">
          <date-span [start]="priceList.valid_from" [end]="priceList.valid_to"></date-span>

          <form
            (ngSubmit)="newPriceList ? onSubmit.emit(priceList) : updatePriceList()"
            autocomplete="off"
          >
            <div class="margin-top--3x">
              <button type="submit" class="button primary">{{ saveButtonLabel }}</button>
              <button type="button" class="button primary-2" (click)="goToProducts()">Avbryt</button>
            </div>

            <div class="row">
              <div class="col-md-6">
                <h3 class="margin-top--3x margin-bottom--3x text--dark-gray">Placeringspris</h3>
                <table class="table table--woo table-hover table--light-red">
                  <thead>
                    <tr>
                      <th>Publicist</th>
                      <th>Produkt</th>
                      <th>{{ priceHeadingLabel }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (basePrice of basePriceList; let i = $index; track $index) {
                      <tr>
                        <td class="vertical-align--middle">{{ getPublisherName(basePrice.publisherId) }}</td>
                        <td class="vertical-align--middle">{{ translateProductFormat(basePrice.product) }}</td>
                        <td>
                          <div class="input__container">
                            <input
                              type="text"
                              name="{{ basePrice.publisherId + basePrice.product }}"
                              [(ngModel)]="priceList.publisher_base_prices[basePrice.publisherId][basePrice.product]"
                              required
                              class="form-control"
                            />
                          </div>
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>

              <div class="col-md-6">
                <h3 class="margin-top--3x margin-bottom--3x text--dark-gray">Styrningspris</h3>
                <table class="table table--woo table-hover table--light-red">
                  <thead>
                    <tr>
                      <th>Publicist</th>
                      <th>Styrning</th>
                      <th>{{ priceHeadingLabel }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (targetingPrice of targetingPriceList; let i = $index; track $index) {
                      <tr>
                        <td class="vertical-align--middle">{{ getPublisherName(targetingPrice.publisherId) }}</td>
                        <td class="vertical-align--middle">{{ translateTargetingProduct(targetingPrice.product) }}</td>
                        <td>
                          <div class="input__container">
                            <input
                              type="text"
                              name="{{ targetingPrice.publisherId + targetingPrice.product }}"
                              [(ngModel)]="priceList.publisher_targeting_prices[targetingPrice.publisherId][targetingPrice.product]"
                              required
                              class="form-control"
                            />
                          </div>
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <h3 class="margin-top--3x margin-bottom--3x text--dark-gray">Geografipris</h3>
                <table class="table table--woo table-hover table--light-red">
                  <thead>
                    <tr>
                      <th>Publicist</th>
                      <th>Geografi</th>
                      <th>{{ priceHeadingLabel }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (localityPrice of localityPriceList; let i = $index; track $index) {
                      <tr>
                        <td class="vertical-align--middle">{{ getPublisherName(localityPrice.publisherId) }}</td>
                        <td class="vertical-align--middle">{{ translateLocality(localityPrice.product) }}</td>
                        <td>
                          <div class="input__container">
                            <input
                              type="text"
                              name="{{ localityPrice.publisherId + localityPrice.product }}"
                              [(ngModel)]="priceList.publisher_locality_prices[localityPrice.publisherId][localityPrice.product]"
                              required
                              class="form-control"
                            />
                          </div>
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>

              <div class="col-md-6">
                <h3 class="margin-top--3x margin-bottom--3x text--dark-gray">Tilläggsstyrning</h3>
                <table class="table table--woo table-hover table--light-red">
                  <thead>
                    <tr>
                      <th>Publicist</th>
                      <th>Styrning</th>
                      <th>{{ priceHeadingLabel }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (addonPrice of addonTargetingPriceList; let i = $index; track $index) {
                      <tr>
                        <td class="vertical-align--middle">{{ getPublisherName(addonPrice.publisherId) }}</td>
                        <td class="vertical-align--middle">{{ translateTargetingProduct(addonPrice.product) }}</td>
                        <td>
                          <div class="input__container">
                            <input
                              type="text"
                              name="{{ addonPrice.publisherId + addonPrice.product }}"
                              [(ngModel)]="priceList.publisher_addon_targeting_prices[addonPrice.publisherId][addonPrice.product]"
                              required
                              class="form-control"
                            />
                          </div>
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <h3 class="margin-top--3x margin-bottom--3x text--dark-gray">Åldersgrupp priser</h3>
                <table class="table table--woo table-hover table--light-red">
                  <thead>
                    <tr>
                      <th>Publicist</th>
                      <th>Åldersgrupp</th>
                      <th>{{ priceHeadingLabel }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (agePrice of ageModifierPriceList; let i = $index; track $index) {
                      <tr>
                        <td class="vertical-align--middle">{{ getPublisherName(agePrice.publisherId) }}</td>
                        <td class="vertical-align--middle">{{ translateAgeModifierKey(agePrice.product) }}</td>
                        <td>
                          <div class="input__container">
                            <input
                              type="text"
                              name="{{ agePrice.publisherId + agePrice.product }}"
                              [(ngModel)]="priceList.publisher_age_modifier_prices[agePrice.publisherId][agePrice.product]"
                              required
                              class="form-control"
                            />
                          </div>
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>

              <div class="col-md-6">
                <h3 class="margin-top--3x margin-bottom--3x text--dark-gray">Programformats priser</h3>
                <table class="table table--woo table-hover table--light-red">
                  <thead>
                    <tr>
                      <th>Programformat</th>
                      <th>{{ priceHeadingLabel }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (programPrice of priceList.program_display_prices; let i = $index; track $index) {
                      <tr>
                        <td class="vertical-align--middle">{{ programPrice.name }}</td>
                        <td>
                          <div class="input__container">
                            <input
                              type="text"
                              name="{{ programPrice.id + programPrice.name }}"
                              [(ngModel)]="priceList.program_modifier_prices[programPrice.id]"
                              required
                              class="form-control"
                            />
                          </div>
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <h3 class="margin-top--3x margin-bottom--3x text--dark-gray">Veckoindex</h3>
              </div>
            </div>

            <div class="row">
              @for (weeks of weekIndexWeeks; let i = $index; track $index) {
                <div class="col-md-6 border--info">
                  <table class="table table--woo table-hover table--light-red">
                    <thead>
                      <tr>
                        <th>Vecka</th>
                        <th>Video</th>
                        <th>Pausreklam</th>
                      </tr>
                    </thead>
                    <tbody>
                      @for (week of weeks; let j = $index; track $index) {
                        <tr>
                          <td class="vertical-align--middle"><strong>{{ week }}</strong></td>
                          <td>
                            <div class="input__container">
                              <input
                                type="text"
                                name="week_index_{{ week }}"
                                [(ngModel)]="priceList.week_price_indexes[week - 1]"
                                required
                                class="form-control"
                              />
                            </div>
                          </td>
                          <td>
                            <div class="input__container">
                              <input
                                type="text"
                                name="pause_ad_week_index_{{ week }}"
                                [(ngModel)]="priceList.pause_ad_week_price_indexes[week - 1]"
                                required
                                class="form-control"
                              />
                            </div>
                          </td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              }
            </div>

            <div class="row margin-top--3x">
              <div class="col-md-6 border--info">
                <h3 class="margin-top--3x margin-bottom--3x text--dark-gray">Filmindex</h3>
                <table class="table table--woo table-hover table--light-red">
                  <thead>
                    <tr>
                      <th>Filmlängd</th>
                      <th>Index</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (length of creativeLengths; let i = $index; track $index) {
                      <tr>
                        <td class="vertical-align--middle"><strong>{{ length }}</strong></td>
                        <td>
                          <div class="input__container">
                            <input
                              type="text"
                              name="creative_length_price_indexes{{ length }}"
                              [(ngModel)]="priceList.creative_length_price_indexes[length]"
                              required
                              class="form-control"
                            />
                          </div>
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            </div>

            <h3 class="margin-top--3x margin-bottom--3x text--dark-gray">Frekvenstaksindex</h3>
            <table class="table table--woo table-hover table--light-red">
              <thead>
                <tr>
                  <th>Frekvenstak</th>
                  <th>Index</th>
                </tr>
              </thead>
              <tbody>
                @for (price of getActivePrices(priceList.frequency_limit_prices); let i = $index; track $index) {
                  <tr>
                    <td class="vertical-align--middle">{{ price.frequency_limit.name }}</td>
                    <td>
                      <div class="input__container">
                        <input
                          type="text"
                          name="ratio_{{ price.id }}"
                          [(ngModel)]="price.ratio"
                          required
                          class="form-control"
                        />
                      </div>
                    </td>
                  </tr>
                }
              </tbody>
            </table>

            <div class="margin-top--3x">
              <button type="submit" class="button primary">{{ saveButtonLabel }}</button>
              <button type="button" class="button primary-2" (click)="goToProducts()">Avbryt</button>
            </div>
          </form>
        </div>
      }
    </div>
  </div>
</div>
